import styled from 'styled-components';

const RecipientsWrapper = styled.div``;

const RecipientsHeader = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 16px;
`;

const BadgeWrapper = styled.div`
  display: flex;
  gap: 4px;
`;

export { BadgeWrapper, RecipientsHeader, RecipientsWrapper };
